import { useSelector } from 'react-redux';
import type AmplitudeAnalyticsSettings from '@alltrails/types/AmplitudeAnalyticsSettings';

export default function useAmplitudeAnalyticsSettings(): AmplitudeAnalyticsSettings {
  return useSelector((state: { amplitudeAnalyticsSettings: AmplitudeAnalyticsSettings }) => state.amplitudeAnalyticsSettings);
}
